var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myRankView"},[_c('div',{staticClass:"myRankView__header"},[_vm._v(" "+_vm._s(_vm.$t('rankingHeaderUser', { userName: _vm.result.streamerUser.nickname }))+" ")]),_c('ranking-cell',{attrs:{"result":_vm.result}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }